export default __webpack_public_path__ + "static/media/info_white.0aadda13.svg";